import React from 'react'

import { StarRatingBadge } from '../../../../../product-page/components/StarRatingBadge'

export const getStarRating = (value: string) => {
  return <StarRatingBadge value={value} />
}
